import React from 'react';

const BACKEND_BASE_URL =
    process.env.REACT_APP_BACKEND_URL ||
    process.env.REACT_APP_API_BASE_URL?.replace('/api', '') ||
    'http://localhost:8000';

const resolveLogoSrc = (logoUrl) => {
    if (!logoUrl) return null;
    if (logoUrl.startsWith('http')) return logoUrl;
    return `${BACKEND_BASE_URL}${logoUrl.startsWith('/') ? '' : '/'}${logoUrl}`;
};

const ClinicBrandLogo = ({
    logoUrl,
    clinicName,
    fallbackText,
    className = '',
    imageClassName = '',
    textClassName = '',
}) => {
    const src = resolveLogoSrc(logoUrl);
    const text = clinicName || fallbackText || 'Clinic';

    return (
        <div className={className}>
            {src ? (
                <img src={src} alt={text} className={imageClassName} />
            ) : (
                <span className={textClassName}>{text}</span>
            )}
        </div>
    );
};

export default ClinicBrandLogo;
